import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

import { LayoutParagraphPage, PTypes } from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { DynamicContentWrapperComponent } from '../dynamic-content-wrapper/dynamic-content-wrapper.component';

@Component({
  selector: 'digital-platform-layout-paragraph-page',
  standalone: true,
  imports: [CommonModule, DynamicContentWrapperComponent],
  templateUrl: './layout-paragraph-page.component.html',
  styleUrls: ['./layout-paragraph-page.component.scss'],
})
export class LayoutParagraphPageComponent
  extends BasePTypeComponent
  implements OnChanges, LayoutParagraphPage
{
  public override type = 'layoutParagraphPage' as const;

  @Input() public title = '';
  @Input() public contentContainer: PTypes[] = [];

  public newContent: PTypes[] = [];

  ngOnChanges() {
    if (this.contentContainer.length === 0) {
      this.newContent = [];
    }
    this.newContent = this.contentContainer
      .map((parent: PTypes) => {
        const children = this.contentContainer.filter((child: PTypes) => {
          const parentUuid =
            child.behaviorSettings?.layout_paragraphs?.parent_uuid;
          if (child.uuid !== parentUuid && parentUuid === parent.uuid) {
            return true;
          }
          return false;
        });

        if (children.length) {
          (parent as any).children = children;
        }

        return parent;
      })
      .filter((obj: PTypes) => {
        const parentUuid =
          obj.behaviorSettings?.layout_paragraphs?.parent_uuid ?? undefined;
        return !parentUuid;
      });
  }
}
